import t from "moment";
function c(e, f) {
  const n = t(e), o = t(f);
  return n.utcOffset() - o.utcOffset();
}
export {
  c as default
};
